module.exports = __webpack_public_path__ + "/content/skins/acme/fav/safari-pinned-tab.svg";